module.exports = __webpack_public_path__ + "media/images/icons/contract-092ce6ee7d26780525f453a4648ac809.svg";